import styled from 'styled-components';
import { mediaAppMobile } from 'styles/grid';

interface CampaignsContainerProps {
  layout: 'small' | 'medium' | 'large';
}
// using rem for screen size responsive
const CampaignsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  ${mediaAppMobile} {
    flex-direction: column;
  }
`;

const LeftCampaign = styled.div<CampaignsContainerProps>`
  width: ${({ layout }) => {
    if (layout === 'small') return 'calc(33% - 8px)';
    if (layout === 'medium') return 'calc(50% - 8px)';
    return 'none';
  }};
  height: auto;
  ${mediaAppMobile} {
    width: 100%;
  }
`;

const CenterCampaign = styled.div<CampaignsContainerProps>`
  width: ${({ layout }) => {
    if (layout === 'small') return 'calc(33% - 8px)';
    if (layout === 'medium') return 'calc(50% - 8px)';
    return 'auto';
  }};
  height: auto;
  ${mediaAppMobile} {
    width: 100%;
  }
`;

const RightCampaign = styled.div<CampaignsContainerProps>`
  width: ${({ layout }) => {
    if (layout === 'small') return 'calc(33% - 8px)';
    if (layout === 'medium') return 'calc(50% - 8px)';
    return 'auto';
  }};
  height: auto;
  ${mediaAppMobile} {
    width: 100%;
  }
`;

export { CampaignsContainer, CenterCampaign, LeftCampaign, RightCampaign };
